import React from "react";
import { Button } from "@/components/ui/button";
import UserProfile from "@/pages/profile/User";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import CtaCard from "@/components/banners/CtaCard";
import researchImage from "/images/research.png";
import usePlanStore from "@/stores/planStore";

import { useFeatureFlagPayload, useFeatureFlagEnabled } from "posthog-js/react";

export default function Actions() {
  const isTestEnabled = useFeatureFlagEnabled("launch-research-test");
  const test = useFeatureFlagPayload("launch-research-test");
  const { canPublish } = usePlanStore((state) => state);

  return (
    <div className="bg-gray-50 py-16 sm:py-20 min-h-screen">
      <div className="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">
        <div>
          <h1 className="mt-2 text-4xl font-bold tracking-tight sm:text-5xl text-pretty">
            Empieza a conectar con tus clientes
          </h1>
          <p className="text-xl text-gray-500 text-pretty font-regular">
            Te damos la bienvenida a Casas y Terrenos
          </p>
        </div>

        <div className="mt-10 grid gap-6 sm:mt-16 lg:grid-cols-3">
          {/* Profile Widget */}
          <Card className="relative col-span-2 lg:col-span-1 row-span-2 shadow-md">
            <CardHeader>
              <CardTitle className="text-lg font-medium">
                Tu información de contacto
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="mb-4 text-sm text-gray-600">
                Así es como tus datos de contacto se mostrarán a otros usuarios
                en la plataforma:
              </p>
              <UserProfile />
            </CardContent>
          </Card>

          {/* Create Property Card */}
          <div className="relative col-span-2 lg:col-span-1">
            <div className="absolute inset-px rounded-lg bg-white"></div>
            <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)]">
              <div className="px-8 pt-8 sm:px-10 sm:pt-10">
                <p className="mt-2 text-lg font-medium tracking-tight text-gray-950 max-lg:text-center">
                  Crea una propiedad
                </p>
                <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
                  Empieza a publicar ahora mismo! Publica tantas propiedades en
                  renta como quieras o adquiere un plan para publicar todas tus
                  propiedades en venta.
                </p>
              </div>
              <div className="flex flex-1 items-center justify-center px-8 max-lg:pt-10 max-lg:pb-12 sm:px-10 lg:pb-2">
                <a
                  href={canPublish ? "/properties/create" : undefined}
                  className={`w-full ${
                    !canPublish ? "pointer-events-none opacity-60" : ""
                  }`}
                  onClick={(e) => {
                    if (!canPublish) e.preventDefault();
                  }}
                  aria-disabled={!canPublish}
                  title={
                    !canPublish
                      ? "Tu plan no permite crear propiedades."
                      : "Crear propiedad"
                  }
                >
                  <Button className="w-full" disabled={!canPublish}>
                    Crear propiedad
                  </Button>
                </a>
              </div>
            </div>
            <div className="pointer-events-none absolute inset-px rounded-lg shadow-xs ring-1 ring-black/5"></div>
          </div>

          {/* Investigations Card */}

          {isTestEnabled ? (
            <CtaCard
              title={test?.title}
              subtitle={test?.subtitle}
              description={test?.description}
              ctaLabel={test?.ctaLabel}
              ctaLink="/investigaciones"
              ctaTrack="home-research-cta-clicked"
              image={researchImage}
            />
          ) : (
            <CtaCard
              title="Investigaciones digitales para renta confiable"
              subtitle="¡Ya está disponible!"
              description="Evalúa a tus prospectos con datos reales y gana $$ por cada investigación."
              ctaLabel="Empezar a ganar"
              ctaLink="/investigaciones"
              ctaTrack="home-research-cta-clicked"
              image={researchImage}
            />
          )}

          {/* Subscription Card */}
          <div className="relative col-span-2">
            <div className="absolute inset-px rounded-lg bg-white"></div>
            <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(var(--radius-lg)+1px)]">
              <div className="px-8 pt-8 pb-3 sm:px-10 sm:pt-10 sm:pb-0 space-y-3">
                <p className="mt-2 text-lg font-medium tracking-tight text-gray-950 max-lg:text-center">
                  Adquiere un plan y obtén acceso a todas las funcionalidades
                </p>
                <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
                  Empieza a crear propiedades, publicar en venta, comparte tus
                  leads y obtén acceso a todas las funcionalidades de Casas y
                  Terrenos.
                </p>
                <div>
                  <a href="/subscription" className="">
                    <Button variant="default" className="w-full">
                      Administrar plan
                    </Button>
                  </a>
                </div>
              </div>
            </div>
            <div className="pointer-events-none absolute inset-px rounded-lg shadow-xs ring-1 ring-black/5"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
